module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-container', {
    attrs: {
      "fluid": ""
    }
  }, [_c('page-title', [_c('h2', [_c('router-link', {
    staticClass: "nav-link",
    attrs: {
      "to": {
        name: 'UserList'
      }
    }
  }, [_vm._v("Użytkownicy")])], 1), _c('div', {
    staticClass: "page-title__buttons"
  }, [_c('router-link', {
    staticClass: "btn btn-default",
    attrs: {
      "to": {
        name: 'UserCreate'
      }
    }
  }, [_c('span', [_vm._v("Dodaj użytkownika")]), _c('svg-icon', {
    attrs: {
      "name": "plus"
    }
  })], 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col page-element"
  }, [(_vm.loading) ? _c('alert-loading') : _vm._e(), _vm._v(" "), (_vm.deletedItem) ? _c('div', {
    staticClass: "alert alert-success"
  }, [_vm._v(_vm._s(_vm.deletedItem['@id']) + " deleted.")]) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('div', {
    staticClass: "alert alert-danger"
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), (!_vm.loading) ? _c('div', [_c('div', {
    staticClass: "table-responsive"
  }, [_c('table', {
    staticClass: "table table-striped table-bordered table-hover table-clickable table-search"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Imię")]), _vm._v(" "), _c('th', [_vm._v("Nazwisko")]), _vm._v(" "), _c('th', [_vm._v("E-mail")]), _vm._v(" "), _c('th')])]), _vm._v(" "), _c('tbody', _vm._l((_vm.items), function(item) {
    return _c('tr', [_c('td', [(item) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'UserShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['name']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'UserShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['surname']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [(item) ? _c('router-link', {
      staticClass: "link",
      attrs: {
        "to": {
          name: 'UserShow',
          params: {
            id: item['id']
          }
        }
      }
    }, [_vm._v(_vm._s(item['email']))]) : _vm._e()], 1), _vm._v(" "), _c('td', [_c('router-link', {
      directives: [{
        name: "b-tooltip",
        rawName: "v-b-tooltip.hover.bottom",
        modifiers: {
          "hover": true,
          "bottom": true
        }
      }],
      staticClass: "btn btn-icon",
      attrs: {
        "to": {
          name: 'UserUpdate',
          params: {
            id: item['id']
          }
        },
        "title": "Edytuj użytkownika"
      }
    }, [_c('svg-icon', {
      attrs: {
        "name": "edit"
      }
    })], 1)], 1)])
  }), 0)])]), _vm._v(" "), _c('pagination', {
    attrs: {
      "changePage": _vm.changePage,
      "currentPage": _vm.currentPage,
      "pagination": _vm.pagination
    }
  })], 1) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-09bb55d0","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/List.vue
// module id = 777
// module chunks = 0